import { Language } from '../i18n'

// Used only when GET /countries is unreachable.
export const FALLBACK_COUNTRY_CODES = ['AU', 'BE', 'CN', 'DE', 'DK', 'GB', 'IT', 'JP', 'NL', 'PL', 'SG', 'US']

export type CountryOption = {
	code: string
	label: string
}

export const getCountryLabel = (code: string, language: Language): string => {
	try {
		return new Intl.DisplayNames([language], { type: 'region' }).of(code) ?? code
	} catch {
		return code
	}
}

export const getCountryOptions = (codes: string[], language: Language): CountryOption[] => {
	return codes
		.map((code) => ({ code, label: getCountryLabel(code, language) }))
		.sort((a, b) => a.label.localeCompare(b.label, language))
}
